import { deviceType } from "@tm/isomorphic-utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export interface TextButtonStyleProps {
  fullWidth?: boolean;
  hasBorder?: boolean;
  disabled?: boolean;
}

export const TextButtonContainer = styled.button<TextButtonStyleProps>`
  /* Reset default button styles to make it look like text */
  background: ${theme.whiteText};
  border: none;
  padding: 0;
  display: flex;
  gap: 2px;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  cursor: pointer;
  outline: none;
  position: relative;
  transition: opacity 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};

  /* Remove default button styling */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  text-align: left;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Ensure it looks like a text button, not a traditional button */
  box-shadow: none;

  img,
  svg {
    width: 100%;
    height: 100%;
    display: block;
    ${(props) =>
      props.disabled &&
      `
      filter: grayscale(100%);
      opacity: 0.90;
    `}
  }

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }

  /* Allow pointer events even when disabled to enable tooltip hover */
  &:disabled {
    pointer-events: auto;
    cursor: not-allowed;
  }

  @media ${deviceType.mobile} {
    padding: 16px 12px;
  }
`;

export const TextButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1;
  min-width: 0;
  width: 100%;

  span {
    flex: 1 0 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
`;

export const LeftIconWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const RightIconWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const TextButtonIcon = styled.div<{
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img,
  svg {
    width: 100%;
    height: 100%;
    display: block;
    ${(props) =>
      props.disabled &&
      `
      filter: grayscale(100%);
      opacity: 0.90;
    `}
  }
`;
